import defaultPosition from "@/helpers/wc/positionSettings";

export const visitorsListSettings = {
  title: 'Visitors List',
  name: 'visitorsListBase',
  styles: defaultPosition,

  properties: {
    deleteSymbol: '',
    css: {
      list: {
        backgroundColor: 'grey',
        borderColor: 'grey',
        borderWidth: '0px',
        borderRadius: '0px',
      },
      item: {
        color: '#fff',
        borderColor: 'grey',
        borderWidth: '0px',
        padding: '16px',
        fontSize: '16px',
        fontFamily: 'sans-serif',
        textAlign: 'left',
      },
    }
  },
  cssLegend: {
    list: {
      backgroundColor: {
        type: 'color',
        name: 'backgroundColor'
      },
      borderColor: {
        type: 'color',
        name: 'border'
      },
      borderWidth: {
        type: 'int',
        name: 'borderWidth',
        handler: val => val + 'px'
      },
      borderRadius: {
        type: 'int',
        name: 'borderRadius',
        handler: val => val + 'px'
      },
    },
    item: {
      color: {
        type: 'color',
        name: 'color'
      },
      borderColor: {
        type: 'color',
        name: 'border'
      },
      borderWidth: {
        type: 'int',
        name: 'borderWidth',
        handler: val => val + 'px'
      },
      padding: {
        type: 'int',
        name: 'paddingLeftRight',
        handler: val => val + 'px'
      },
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      fontFamily: {
        type: 'fontFamily',
        name: 'fontFamily'
      },
      textAlign: {
        type: 'align',
        name: 'align'
      },
    }
  }
};
